module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "value-import-origin",
    class: 'origin-' + _vm.value,
    attrs: {
      "title": _vm.$t('models.project_lead.import_origins.' + _vm.value)
    }
  }, [_c('i', {
    staticClass: "icon"
  }, [_vm._v(_vm._s(_vm.icon))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69d0c814","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueImportOrigin.vue
// module id = 1929
// module chunks = 0